import React from 'react'

import "./Footer.css";

const Footer = props => {
  return (
    <>
    {/* <div className="ff">footer</div> */}
    <footer>
      {/* <div className="waves">
        <div className="wave" id="wave1"></div>
        <div className="wave" id="wave2"></div>
        <div className="wave" id="wave3"></div>
        <div className="wave" id="wave4"></div>

      </div> */}
      {/* <ul className="social_icon">
        <li><a href="/"> </a>hello </li>
        <li><a href="/"> </a>hello </li>
        <li><a href="/"> </a>hello </li>
        <li><a href="/"> </a>hello </li>
      </ul> */}

      <ul className="menu">
        <li><a href="/"> Home </a> </li>
        <li><a href="/about"> About </a> </li>
        <li><a href="/gallery"> Gallery </a> </li>
        <li><a href="/sponsors"> Contact </a> </li>
      </ul>
      <p>©2022 NAKSHATRA | All Rights Reserved</p>
    </footer>
    </>
  )
}


export default Footer;